/** Text elements with this `subtype` render `text` as LaTeX via KaTeX. */
export const EXCALIDRAW_MATH_SUBTYPE = "math" as const;
